<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>
        <el-select
          clearable
          class="mr10"
          size="small"
          v-model="searchCondition.enabledState"
          placeholder="请选择活动状态"
        >
          <el-option label="上线" value="yes"></el-option>
          <el-option label="下线" value="no"></el-option>
        </el-select>
        <el-select
          clearable
          class="mr10"
          size="small"
          v-model="searchCondition.activityType"
          placeholder="请选择活动类型"
        >
          <el-option
            :label="v.gameName"
            :value="v.gameCode"
            :key="i"
            v-for="(v, i) in gameTypeList"
          ></el-option>
        </el-select>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.spreadName"
          placeholder="请输入活动名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>

    <div class="hm-radio-group">
      <el-radio-group
        v-model="searchCondition.activityStatus"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="0"
          >全部({{ stateCount.totalCount || 0 }})</el-radio-button
        >
        <el-radio-button label="2">
          进行中({{ stateCount.ongoingCount || 0 }})
        </el-radio-button>
        <el-radio-button label="1">
          未开始({{ stateCount.notStartCount || 0 }})
        </el-radio-button>
        <el-radio-button label="3"
          >已结束({{ stateCount.endCount || 0 }})</el-radio-button
        >
      </el-radio-group>
    </div>
    <el-table :data="list" style="width: 100%" stripe border size="small">
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>

      <el-table-column
        header-align="center"
        align="center"
        prop="spreadName"
        label="活动名称"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="gameType"
        label="活动类型"
        width="180"
        key="gameType"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.spreadTarget == 'guider'"
            >导购邀请供应商奖励活动</span
          >
          <span v-else-if="scope.row.spreadTarget == 'supplier'"
            >业务员邀请供应商奖励活动</span
          >
          <span v-else-if="scope.row.spreadTarget == 'store'"
            >采购邀请供应商奖励活动</span
          >
          <span v-else-if="scope.row.spreadTarget == 'redpackageVideoAd'"
            >微信广告激励红包</span
          >
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="createTime"
        label="活动创建时间"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="enabledState"
        label="活动状态"
      >
        <template slot-scope="scope">
          <span class="success" v-show="scope.row.enabledState === 'yes'"
            >上线</span
          >
          <span class="danger" v-show="scope.row.enabledState === 'no'"
            >下线</span
          >
        </template>
      </el-table-column>
      <el-table-column
        width="250"
        label="操作"
        header-align="center"
        align="left"
      >
        <template slot-scope="scope">
          <div class="flex flex-center item-center" v-if="scope.row.spreadTarget !== 'redpackageVideoAd'">
            <el-button
              size="small"
              type="text"
              @click="toReservitionList(scope.row)"
              >参与活动记录</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <!-- <el-button
              size="small"
              type="text"
              @click="productQrcode(scope.row)"
              >活动二维码</el-button
            >
            <el-divider direction="vertical"></el-divider> -->
            <el-button size="small" type="text" @click="copy(scope.row)"
              >复制</el-button
            >
          </div>
          <div class="flex flex-center item-center">

            <el-button
              size="small"
              v-if="scope.row.enabledState === 'no'"
              type="text"
              @click="updateState(scope.row)"
              >上线</el-button
            >

            <el-button
              size="small"
              v-if="scope.row.enabledState === 'yes'"
              type="text"
              @click="updateState(scope.row)"
              >下线</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button size="small" type="text" @click="toDetails(scope.row)"
              >查看</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button size="small" type="text" @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-divider direction="vertical" v-if="scope.row.spreadTarget === 'redpackageVideoAd'"></el-divider>
            <el-button size="small" type="text" @click="copy(scope.row)"
              v-if="scope.row.spreadTarget === 'redpackageVideoAd'"
              >复制</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      title="请用微信扫一扫"
      :visible.sync="qrcodeDialogVisible"
      :modal="false"
      width="250px"
    >
      <div class="qrcode-wrapper">
        <img style="width: 100%" :src="activityCode" alt="二维码" />
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="参与活动记录"
      width="1200px"
      :visible.sync="dialogVisibleReservition"
    >
      <div class="mb10 flex flex-between">
        <el-radio-group
          v-model="spreadLogType"
          size="small"
          @change="recordTypeTab"
        >
          <el-radio-button label="1">邀请记录</el-radio-button>
          <el-radio-button label="2">红包领取记录</el-radio-button>
        </el-radio-group>
        <div>
          <el-input
            clearable
            style="width: 250px"
            v-model.trim="memberMobile"
            placeholder="请输入手机号"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="searchPart"
            >查询</el-button
          >
          <el-button
            type="success"
            size="small"
            @click="
              outputPart(spreadLogType === '1' ? '邀请记录' : '红包领取记录')
            "
            :loading="isOutputing"
            >导出</el-button
          >
        </div>
      </div>
      <div>
        <div class="flex mb10" v-if="spreadLogType === '2'">
          <div class="mr20">
            已发放红包
            <span class="primary">{{ redpackageMoneyInfo.sendMoney }}元</span>
          </div>
          <div class="mr20">
            红包限制
            <span class="primary">{{ redpackageMoneyInfo.totalMoney }}元</span>
          </div>
          <div class="mr20">
            剩余
            <span class="primary"
              >{{ redpackageMoneyInfo.surplusMoney }}元</span
            >
          </div>
        </div>
        <el-table
          :data="participateList"
          style="width: 100%"
          stripe
          border
          max-height="500"
          ref="tablePart"
          size="small"
          v-if="spreadLogType === '1'"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            key="joinId"
            :index="index => index + (currentPagePart - 1) * pageSizePart + 1"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="gameType"
            label="活动类型"
            width="180"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.spreadTarget == 'guider'"
                >导购邀请供应商奖励活动</span
              >
              <span v-else-if="scope.row.spreadTarget == 'supplier'"
                >业务员邀请供应商奖励活动</span
              >
              <span v-else-if="scope.row.spreadTarget == 'store'"
                >采购邀请供应商奖励活动</span
              >
            </template>
          </el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="spreadName"
            label="活动名称"
            key="spreadName"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="参与手机号"
            prop="memberMobile"
            key="memberMobile"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="参与者姓名"
            prop="memberName"
            key="memberName"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="参与时间"
            prop="shareTime"
            key="shareTime"
          >
          </el-table-column>
        </el-table>
        <el-table
          :data="participateList"
          style="width: 100%"
          stripe
          border
          max-height="500"
          ref="tablePart"
          size="small"
          v-else
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            key="joinId"
            :index="index => index + (currentPagePart - 1) * pageSizePart + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="gameType"
            label="活动类型"
            width="180"
            key="gameType"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.spreadTarget == 'guider'"
                >导购邀请供应商奖励活动</span
              >
              <span v-else-if="scope.row.spreadTarget == 'supplier'"
                >业务员邀请供应商奖励活动</span
              >
              <span v-else-if="scope.row.spreadTarget == 'store'"
                >采购邀请供应商奖励活动</span
              >
              <span v-else-if="scope.row.spreadTarget == 'redpackageVideoAd'"
                >微信广告激励红包</span
              >
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spreadName"
            label="活动名称"
            key="spreadName"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="邀请者奖励金额"
            prop="shareRewardMoney"
            key="shareRewardMoney"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="receiveRewardMoney"
            label="被邀请者奖励金额"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shareInfo"
            label="邀请者信息"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="receiveInfo"
            label="被邀请者手机号"
          ></el-table-column>
        </el-table>

        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalPart"
            @size-change="handleSizeChangePart"
            @current-change="pagingPart"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPagePart"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="活动上线操作"
      :visible.sync="onlineDialogVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rule"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="上线验证码" prop="verificationCode">
          <el-input
            style="width: 300px"
            size="small"
            clearable
            class="mr10 ipt"
            maxlength="25"
            v-model.trim="ruleForm.verificationCode"
            placeholder="请输入验证码"
          ></el-input>
          <el-button @click="send" size="small" type="primary">
            {{ show ? "发送" : `${time}秒后获取` }}
          </el-button>
          <div class="form-item-tip">
            点击发送验证码会给禾苗管理账户邮箱发送一个验证码 <br />
            请向管理人员索取后验证提交
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitForm('ruleForm')" size="small" type="primary">
          确 认</el-button
        >
        <el-button size="small" @click="onlineDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      redpackageMoneyInfo: {},
      show: true,
      onlineDialogVisible: false,
      spreadLogType: "1",
      participateList: [],
      totalPart: 0,
      currentPagePart: 1,
      pageSizePart: 10,
      dialogVisibleReservition: false,
      gameTypeList: [
        {
          gameName: "导购邀请供应商奖励活动",
          gameCode: "guider"
        },
        {
          gameName: "业务员邀请供应商奖励活动",
          gameCode: "supplier"
        },
        {
          gameName: "采购邀请供应商奖励活动",
          gameCode: "store"
        },
        {
          gameName: "微信广告激励红包",
          gameCode: "redpackageVideoAd"
        }
      ],
      activityCode: "",
      qrcodeDialogVisible: false,
      isOutputing: false,
      stateCount: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      memberMobile: "",
      searchCondition: {
        activityStatus: "0",
        activityType: ""
      },
      ruleForm: {
        verificationCode: ""
      },
      rule: {
        verificationCode: {
          required: true,
          message: "请输入验证码"
        }
      },
      row: {},
      time: 59,
      timer: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (this.$route.query.activityType) {
      this.searchCondition.activityType = this.$route.query.activityType;
    }
    this.queryList();
  },
  methods: {
    async send() {
      if (this.show) {
        const { code } = await this.$store.dispatch(
          "redpackageSpreadSendOnlineMail",
          {
            spreadId: this.row.id
          }
        );
        if (code === "0") {
          this.$message({
            message: "操作成功！",
            type: "success"
          });
          this.time = 59;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.time < 1) {
              clearInterval(this.timer);
              this.show = true;
            } else {
              --this.time;
            }
          }, 1000);
        }
      }
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = {
          spreadId: this.row.id,
          enabledState: "yes",
          verificationCode: this.ruleForm.verificationCode
        };
        const { code } = await this.$store.dispatch(
          "updateSpreadAcitivityEnabledState",
          params
        );
        if (code === "0") {
          this.$message({
            message: "操作成功！",
            type: "success"
          });
          this.ruleForm.verificationCode = "";
          this.onlineDialogVisible = false;
          this.show = true;
          clearInterval(this.timer);
          this.time = 0;
          this.queryList();
        }
      } else {
        return false;
      }
    },
    pagingPart(page) {
      this.currentPagePart = page;
      this.quertReservitionList();
    },
    recordTypeTab() {
      this.participateList = [];
      this.totalPart = 0;
      this.pageSizePart = 10;
      this.currentPagePart = 1;
      this.quertReservitionList();
    },
    handleSizeChangePart(size) {
      this.currentPagePart = 1;
      this.pageSizePart = size;
      this.quertReservitionList();
    },
    searchPart() {
      this.currentPagePart = 1;

      this.quertReservitionList();
    },
    edit(row) {
      let name="";
      if(row.spreadTarget==="redpackageVideoAd"){
        name = "SettingRedActNew"
      }else{
        name = "SettingRedAct"
      }
      this.$router.push({
        name: name,
        query: {
          spreadTarget: row.spreadTarget,
          id: row.id,
          type: "edit"
        }
      });
    },
    toDetails(row) {
      let name="";
      if(row.spreadTarget==="redpackageVideoAd"){
        name = "SettingRedActNew"
      }else{
        name = "SettingRedAct"
      }
      this.$router.push({
        name: name,
        query: {
          id: row.id,
          spreadTarget: row.spreadTarget,
          type: "details"
        }
      });
    },
    updateState(row) {
      this.row = row;
      if (row.enabledState === "yes") {
        this.$confirm("是否下线该活动？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let params = {
              spreadId: row.id,
              enabledState: "no"
            };
            this.$store
              .dispatch("updateSpreadAcitivityEnabledState", params)
              .then(res => {
                const { code } = res;
                if (code === "0") {
                  this.$message({
                    message: "操作成功！",
                    type: "success"
                  });
                  this.queryList();
                }
              });
          })
          .catch(() => {});
      } else {
        this.preInspectionRedpackageSpreadActivity(row.id);
      }
    },
    copy(row) {
      let name="";
      if(row.spreadTarget==="redpackageVideoAd"){
        name = "SettingRedActNew"
      }else{
        name = "SettingRedAct"
      }
      this.$router.push({
        name: name,
        query: {
          spreadTarget: row.spreadTarget,
          id: row.id,
          type: "copy"
        }
      });
    },
    // async productQrcode(row) {
    //   let path = `/pages/invitation/invitation?id=${row.id}`;

    //   const { result } = await this.$store.dispatch("createCouponQrcode", {
    //     path
    //   });
    //   this.qrcodeDialogVisible = true;
    //   this.activityCode = result;
    // },
    async quertReservitionList() {
      let params = {
        pageNo: this.currentPagePart,
        pageSize: this.pageSizePart,
        spreadId: this.row.id,
        spreadLogType: this.spreadLogType
      };
      if (this.spreadLogType === "1") {
        params.shareMobile = this.memberMobile;
      } else {
        params.keyWord = this.memberMobile;
      }
      // let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // Object.assign(params, searchCondition);

      const { result } = await this.$store.dispatch(
        "queryRedpackageSpreadActivityLog",
        params
      );
      if (this.spreadLogType === "1") {
        const { records, total } = result;
        this.participateList = records;
        this.totalPart = total;
      } else {
        const { logDataInfoList, redpackageMoneyInfo } = result;
        this.redpackageMoneyInfo = redpackageMoneyInfo;
        const { records, total } = logDataInfoList;
        this.participateList = records;
        this.totalPart = total;
      }
      this.$nextTick(() => {
        this.$refs.tablePart.doLayout();
        //给table加一个ref
      });
    },
    async quertReservitionAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999,
        spreadId: this.row.id,
        spreadLogType: this.spreadLogType
      };
      // let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // Object.assign(params, searchCondition);

      const { result } = await this.$store.dispatch(
        "queryAllRedpackageSpreadActivityLog",
        params
      );
      return this.spreadLogType === "1"
        ? result.records
        : result.logDataInfoList.records;
    },
    toReservitionList(row) {
      this.row = row;
      this.currentPagePart = 1;
      this.pageSizePart = 10;
      this.spreadLogType = "1";
      this.quertReservitionList();
      this.dialogVisibleReservition = true;
    },
    outputPart(title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.quertReservitionAllList()
          .then(res => {
            const list = res;
            // if (this.participateType === "participate") {
            //   list.forEach(v => {
            //     v.isDefaultWinner = v.isDefaultWinner === "yes" ? "是" : "否";
            //     v.memberInfo = v.memberName + "/" + v.memberMobile;
            //     v.joinType = v.joinType === "import" ? "导表参加" : "报名参加";
            //   });
            // } else {
            //   list.forEach(v => {
            //     v.joinType = v.joinType === "import" ? "导表参加" : "报名参加";
            //     v.winningType =
            //       v.winningType === "manual" ? "手动开奖" : "自动开奖";
            //     v.memberInfo = v.memberName + "/" + v.memberMobile;
            //   });
            // }

            const tHeader = this.$refs.tablePart.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.tablePart.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            const list = res;
            list.forEach(v => {
              if (v.spreadTarget === "guider") {
                v.gameType = "邀请导购";
              } else if (v.spreadTarget === "supplier") {
                v.gameType = "邀请业务员";
              } else if (v.spreadTarget === "store") {
                v.gameType = "邀请采购";
              }
              if (v.enabledState === "yes") {
                v.enabledState = "上线";
              } else {
                v.enabledState = "下线";
              }
            });
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);

            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "我的活动" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    async queryAllList() {
      let params = {
        pageSize: 99999,
        pageNo: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "redpackageSpreadActivityAllList",
        params
      );

      if (code === "0") {
        return result.pageList.records;
      }
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "redpackageSpreadActivityList",
        params
      );

      if (code === "0") {
        const { pageList, stateCount } = result;
        this.stateCount = stateCount;
        const { records, total } = pageList;
        this.list = records;
        this.total = total;
      }
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async preInspectionRedpackageSpreadActivity(id) {
      let params = {
        id
      };
      const { code, result } = await this.$store.dispatch(
        "preInspectionRedpackageSpreadActivity",
        params
      );
      if (code === "0") {
        if(result==="success"){
          this.onlineDialogVisible = true;
        }
      }
    },
  }
};
</script>
<style lang="scss" scoped></style>
